import { GostFach } from '../../../../../core/data/gost/GostFach';
import { Fach } from '../../../../../asd/types/fach/Fach';
import { Abi30BelegpruefungProjektkurse, cast_de_svws_nrw_core_abschluss_gost_belegpruefung_abi2030_Abi30BelegpruefungProjektkurse } from '../../../../../core/abschluss/gost/belegpruefung/abi2030/Abi30BelegpruefungProjektkurse';
import { AbiturFachbelegung } from '../../../../../core/data/gost/AbiturFachbelegung';
import { GostFachUtils } from '../../../../../core/utils/gost/GostFachUtils';
import { ArrayList } from '../../../../../java/util/ArrayList';
import { GostBelegpruefungsArt } from '../../../../../core/abschluss/gost/GostBelegpruefungsArt';
import { GostBelegpruefung } from '../../../../../core/abschluss/gost/GostBelegpruefung';
import { AbiturdatenManager } from '../../../../../core/abschluss/gost/AbiturdatenManager';
import { GostKursart } from '../../../../../core/types/gost/GostKursart';
import { GostFachbereich } from '../../../../../core/types/gost/GostFachbereich';
import { NullPointerException } from '../../../../../java/lang/NullPointerException';
import { GostSchriftlichkeit } from '../../../../../core/types/gost/GostSchriftlichkeit';
import { GostHalbjahr } from '../../../../../core/types/gost/GostHalbjahr';
import type { List } from '../../../../../java/util/List';
import { Class } from '../../../../../java/lang/Class';
import { GostBelegungsfehler } from '../../../../../core/abschluss/gost/GostBelegungsfehler';

export class Abi30BelegpruefungGesellschaftswissenschaftenUndReligion extends GostBelegpruefung {

	/**
	 * Die Belegungen für alle Fächer der Gesellschaftswissenschaften.
	 */
	private gesellschaftswissenschaften: List<AbiturFachbelegung> | null = null;

	/**
	 * Die Belegung des Faches Geschichte - oder null, falls es nicht belegt wurde.
	 */
	private geschichte: List<AbiturFachbelegung> | null = null;

	/**
	 * Die Belegung des Faches Sozialwissenschaften - oder null, falls es nicht belegt wurde.
	 */
	private sozialwissenschaften: List<AbiturFachbelegung> | null = null;

	/**
	 * Die Belegung des Faches Philosophie - oder null, falls es nicht belegt wurde.
	 */
	private philosophie: AbiturFachbelegung | null = null;

	/**
	 * Die Belegungen für die Fächer Gesellschaftswissenschaften außer Geschichte, Sozialwissenschaften und Philosophie.
	 */
	private sonstige_gesellschaftswissenschaften: List<AbiturFachbelegung> | null = null;

	/**
	 * Die Belegung des Faches Religion - oder null, falls es nicht belegt wurde.
	 */
	private religion: List<AbiturFachbelegung> | null = null;

	/**
	 * Alle Fachbelegungen bei denen Zusatzkurse in zwei aufeinanderfolgenden Halbjahren in der Qualifikationsphase belegt wurden..
	 */
	private zusatzkursFachbelegungen: ArrayList<AbiturFachbelegung> | null = null;


	/**
	 * Erstellt eine neue Belegprüfung für den Bereich der Gesellschaftswissenschaften und Religion.
	 *
	 * @param manager                der Daten-Manager für die Abiturdaten
	 * @param pruefungsArt           die Art der durchzuführenden Prüfung (z.B. EF.1 oder GESAMT)
	 * @param pruefungProjektkurse   das Ergebnis für die Belegprüfung der Projektkurse
	 */
	public constructor(manager: AbiturdatenManager, pruefungsArt: GostBelegpruefungsArt, pruefungProjektkurse: Abi30BelegpruefungProjektkurse) {
		super(manager, pruefungsArt, pruefungProjektkurse);
	}

	protected init(): void {
		this.gesellschaftswissenschaften = this.manager.getRelevanteFachbelegungen(GostFachbereich.GESELLSCHAFTSWISSENSCHAFTLICH);
		this.geschichte = this.manager.getRelevanteFachbelegungen(GostFachbereich.GESCHICHTE);
		this.sozialwissenschaften = this.manager.getRelevanteFachbelegungen(GostFachbereich.SOZIALWISSENSCHAFTEN);
		this.philosophie = this.manager.getRelevanteFachbelegung(GostFachbereich.PHILOSOPHIE);
		this.sonstige_gesellschaftswissenschaften = this.manager.getRelevanteFachbelegungen(GostFachbereich.GESELLSCHAFTSWISSENSCHAFTLICH_SONSTIGE);
		this.religion = this.manager.getRelevanteFachbelegungen(GostFachbereich.RELIGION);
		this.zusatzkursFachbelegungen = new ArrayList();
	}

	protected pruefeEF1(): void {
		this.pruefeGesellschaftswissenschaftenEF1();
		this.pruefeReligionEF1();
	}

	/**
	 * EF1-Prüfung Punkte 8-10:
	 * Prüfe, ob eine Gesellschaftswissenschaft in EF.1 schriftlich belegt wurde und durchgängig belegbar ist
	 *    und ob Geschichte belegt wurde
	 *    und ob Sozialwissenschaften belegt wurde
	 */
	private pruefeGesellschaftswissenschaftenEF1(): void {
		if (!this.manager.pruefeBelegungDurchgehendBelegbarExistiert(this.gesellschaftswissenschaften, GostSchriftlichkeit.BELIEBIG, GostHalbjahr.EF1)) {
			this.addFehler(GostBelegungsfehler.GOST30_GW_10);
		}
		if (!this.manager.pruefeBelegungExistiertMitSchriftlichkeitEinzeln(this.gesellschaftswissenschaften, GostSchriftlichkeit.SCHRIFTLICH, GostHalbjahr.EF1)) {
			this.addFehler(GostBelegungsfehler.GOST30_GW_11);
		}
		if (this.manager.zaehleBelegungInHalbjahren(this.geschichte, GostHalbjahr.EF1) <= 0) {
			this.addFehler(GostBelegungsfehler.GOST30_GE_1_INFO);
		}
		if (this.manager.zaehleBelegungInHalbjahren(this.sozialwissenschaften, GostHalbjahr.EF1) <= 0) {
			this.addFehler(GostBelegungsfehler.GOST30_SW_1_INFO);
		}
	}

	/**
	 * EF1-Prüfung Punkt 11:
	 * Prüfe, ob Religion in EF.1 belegt wurde oder ob Philosophie und eine weitere durchgehend belegbare Gesellschaftswissenschaft belegt wurde.
	 * Falls Philosophie als Ersatz für Religion gewählt wurde, zählt es nicht als durchgehend belegte Gesellschaftswissenschaft.
	 */
	private pruefeReligionEF1(): void {
		if (this.manager.pruefeBelegungExistiert(this.religion, GostHalbjahr.EF1)) {
			return;
		}
		if ((!this.manager.pruefeBelegung(this.philosophie, GostHalbjahr.EF1)) || ((!this.manager.pruefeBelegungDurchgehendBelegbarExistiert(this.geschichte, GostSchriftlichkeit.BELIEBIG, GostHalbjahr.EF1)) && (!this.manager.pruefeBelegungDurchgehendBelegbarExistiert(this.sozialwissenschaften, GostSchriftlichkeit.BELIEBIG, GostHalbjahr.EF1)) && (!this.manager.pruefeBelegungDurchgehendBelegbarExistiert(this.sonstige_gesellschaftswissenschaften, GostSchriftlichkeit.BELIEBIG, GostHalbjahr.EF1)))) {
			this.addFehler(GostBelegungsfehler.GOST30_RE_10);
		}
	}

	protected pruefeGesamt(): void {
		this.pruefeSchriftlichkeitEF();
		this.pruefeDurchgaengigeBelegung();
		this.pruefeDurchgaengigeBelegungUndSchriftlich();
		this.pruefeZusatzkurs(this.geschichte);
		this.pruefeBelegungGeschichte();
		this.pruefeZusatzkurs(this.sozialwissenschaften);
		this.pruefeBelegungSozialwissenschaften();
		this.pruefeReligionEF();
		this.pruefeReligionQ1();
		this.pruefeReligionKontinuitaet();
	}

	/**
	 * Gesamtprüfung Punkt 39:
	 * Prüfe, on in EF.1 und EF.2 jeweils ein Fach der Gesellschaftswissenschaften schriftlich belegt wurde
	 */
	private pruefeSchriftlichkeitEF(): void {
		if ((!this.manager.pruefeBelegungExistiertMitSchriftlichkeitEinzeln(this.gesellschaftswissenschaften, GostSchriftlichkeit.SCHRIFTLICH, GostHalbjahr.EF1)) || (!this.manager.pruefeBelegungExistiertMitSchriftlichkeitEinzeln(this.gesellschaftswissenschaften, GostSchriftlichkeit.SCHRIFTLICH, GostHalbjahr.EF2))) {
			this.addFehler(GostBelegungsfehler.GOST30_GW_11);
		}
	}

	/**
	 * Gesamtprüfung Punkt 38:
	 * Prüfe, ob ein Fach der Gesellschaftswissenschaften von EF.1 bis Q2.2 durchgängig belegt wurde
	 * - Zusatzkurse zählen hier nicht als Belegung
	 */
	private pruefeDurchgaengigeBelegung(): void {
		if (!this.manager.pruefeBelegungExistiert(this.gesellschaftswissenschaften, GostHalbjahr.EF1, GostHalbjahr.EF2, GostHalbjahr.Q11, GostHalbjahr.Q12, GostHalbjahr.Q21, GostHalbjahr.Q22)) {
			this.addFehler(GostBelegungsfehler.GOST30_GW_10);
		}
	}

	/**
	 * Gesamtprüfung Punkt 40:
	 * Prüfe, ob ein Fach der Gesellschaftswissenschaften oder Religionslehre von EF.1 bis Q2.2 belegt
	 * und von Q1.1 bis Q2.1 schriftlich belegt wurde, damit es als potentielles Abiturfach zur Verfügung steht.
	 * - Zusatzkurse zählen hier nicht als Belegung
	 */
	private pruefeDurchgaengigeBelegungUndSchriftlich(): void {
		if (this.manager.pruefeBelegungExistiertDurchgehendSchriftlich(this.gesellschaftswissenschaften)) {
			return;
		}
		if (this.manager.pruefeBelegungExistiertDurchgehendSchriftlich(this.religion)) {
			return;
		}
		const pruefungProjektkurse: Abi30BelegpruefungProjektkurse = (cast_de_svws_nrw_core_abschluss_gost_belegpruefung_abi2030_Abi30BelegpruefungProjektkurse(this.pruefungen_vorher[0]));
		const projektkurs: AbiturFachbelegung | null = pruefungProjektkurse.getProjektkurs();
		const referenzFach: GostFach | null = ((projektkurs !== null) && (projektkurs.idReferenzfach !== null)) ? this.manager.faecher().get(projektkurs.idReferenzfach) : null;
		if ((projektkurs !== null) && (referenzFach !== null) && (projektkurs.abiturFach === 5) && GostFachbereich.GESELLSCHAFTSWISSENSCHAFTLICH_MIT_RELIGION.hat(referenzFach)) {
			const fachbelegung: AbiturFachbelegung | null = this.manager.getFachbelegungByID(referenzFach.id);
			if ((this.manager.pruefeBelegung(fachbelegung, GostHalbjahr.EF1, GostHalbjahr.EF2, GostHalbjahr.Q11, GostHalbjahr.Q12)) && (this.manager.pruefeBelegungMitSchriftlichkeit(fachbelegung, GostSchriftlichkeit.SCHRIFTLICH, GostHalbjahr.Q11, GostHalbjahr.Q12))) {
				return;
			}
		}
		if (this.manager.pruefeBelegung(this.philosophie, ...GostHalbjahr.getQualifikationsphase()) && this.manager.pruefeBelegungMitSchriftlichkeit(this.philosophie, GostSchriftlichkeit.SCHRIFTLICH, GostHalbjahr.Q11, GostHalbjahr.Q12, GostHalbjahr.Q21)) {
			return;
		}
		this.addFehler(GostBelegungsfehler.GOST30_GW_12);
	}

	/**
	 * Gesamtprüfung Punkte 27, 29 und 30:
	 * Prüft, ob der Zusatzkurs genau zwei mal belegt wurde
	 *    und ob ein Zusatzkurs belegt wurde, obwohl im Halbjahr zuvor ein Geschichtskurs belegt wurde.
	 *
	 * @param fachbelegungen   die Fachbelegung für Geschichte oder Sozialwissenschaften
	 */
	private pruefeZusatzkurs(fachbelegungen: List<AbiturFachbelegung> | null): void {
		if ((fachbelegungen === null) || (fachbelegungen.isEmpty())) {
			return;
		}
		const fachbelegungenZK: List<AbiturFachbelegung> | null = this.manager.filterBelegungKursartExistiert(fachbelegungen, GostKursart.ZK);
		if (fachbelegungenZK.isEmpty()) {
			return;
		}
		if (fachbelegungenZK.size() > 1) {
			this.addFehler(GostBelegungsfehler.GOST30_ZK_13);
		}
		const fachbelegung: AbiturFachbelegung | null = fachbelegungenZK.get(0);
		const fach: GostFach | null = this.manager.getFach(fachbelegung);
		if (fach === null) {
			throw new NullPointerException();
		}
		if (GostFachUtils.istBilingual(fach)) {
			this.addFehler(GostBelegungsfehler.GOST30_ZK_13);
		}
		const zFach: Fach | null = Fach.getBySchluesselOrDefault(fach.kuerzel);
		if ((zFach as unknown === Fach.GE as unknown) && (!this.manager.istErlaubtZusatzkursGE())) {
			this.addFehler(GostBelegungsfehler.GOST30_ZK_14);
		}
		if ((zFach as unknown === Fach.SW as unknown) && (!this.manager.istErlaubtZusatzkursSW())) {
			this.addFehler(GostBelegungsfehler.GOST30_ZK_15);
		}
		const halbjahre: List<GostHalbjahr> = this.manager.getHalbjahreKursart(fachbelegung, GostKursart.ZK);
		if (halbjahre.size() === 2) {
			const belegungQ11: boolean = this.manager.pruefeBelegungMitKursart(fachbelegung, GostKursart.ZK, GostHalbjahr.Q11, GostHalbjahr.Q12);
			const belegungQ12: boolean = this.manager.pruefeBelegungMitKursart(fachbelegung, GostKursart.ZK, GostHalbjahr.Q12, GostHalbjahr.Q21);
			const belegungQ21: boolean = this.manager.pruefeBelegungMitKursart(fachbelegung, GostKursart.ZK, GostHalbjahr.Q21, GostHalbjahr.Q22);
			if ((this.zusatzkursFachbelegungen !== null) && (belegungQ11 || belegungQ12 || belegungQ21)) {
				this.zusatzkursFachbelegungen.add(fachbelegung);
			}
			if ((belegungQ11 && (this.manager.zaehleBelegungInHalbjahren(fachbelegungenZK, GostHalbjahr.Q21, GostHalbjahr.Q22) > 0)) || (belegungQ12 && (this.manager.zaehleBelegungInHalbjahren(fachbelegungenZK, GostHalbjahr.Q22) > 0))) {
				this.addFehler(GostBelegungsfehler.GOST30_ZK_18);
			}
		} else
			if (halbjahre.size() > 1) {
				this.addFehler(GostBelegungsfehler.GOST30_ZK_12);
			}
		if (!halbjahre.isEmpty()) {
			const prevHalbjahr: GostHalbjahr | null = halbjahre.get(0).previous();
			if ((prevHalbjahr !== null) && (prevHalbjahr as unknown !== GostHalbjahr.EF2 as unknown) && (prevHalbjahr as unknown !== GostHalbjahr.Q11 as unknown) && (this.manager.pruefeBelegung(fachbelegung, prevHalbjahr))) {
				this.addFehler(GostBelegungsfehler.GOST30_ZK_10);
			}
		}
		if (!halbjahre.isEmpty()) {
			if ((zFach as unknown === Fach.GE as unknown) && (this.manager.getBeginnZusatzkursGE() as unknown !== halbjahre.get(0) as unknown)) {
				this.addFehler(GostBelegungsfehler.GOST30_ZK_16);
			}
			if ((zFach as unknown === Fach.SW as unknown) && (this.manager.getBeginnZusatzkursSW() as unknown !== halbjahre.get(0) as unknown)) {
				this.addFehler(GostBelegungsfehler.GOST30_ZK_17);
			}
		}
	}

	/**
	 * Gesamtprüfung Punkt 41:
	 * Prüft, ob Geschichte korrekt belegt wurde (mind. von EF.1 bis Q1.2 oder als Zusatzkurs)
	 */
	private pruefeBelegungGeschichte(): void {
		if ((this.geschichte === null) || (this.geschichte.isEmpty())) {
			this.addFehler(GostBelegungsfehler.GOST30_GE_10);
			return;
		}
		if (this.manager.pruefeBelegungExistiert(this.geschichte, GostHalbjahr.EF1, GostHalbjahr.EF2, GostHalbjahr.Q11, GostHalbjahr.Q12)) {
			return;
		}
		if (this.zusatzkursFachbelegungen !== null) {
			for (const zkBelegung of this.zusatzkursFachbelegungen) {
				if (this.geschichte.contains(zkBelegung)) {
					return;
				}
			}
		}
		this.addFehler(GostBelegungsfehler.GOST30_GE_10);
	}

	/**
	 * Gesamtprüfung Punkt 42:
	 * Prüft, ob Sozialwissenschaften korrekt belegt wurde (mind. von EF.1 bis Q1.2 oder als Zusatzkurs)
	 */
	private pruefeBelegungSozialwissenschaften(): void {
		if ((this.sozialwissenschaften === null) || (this.sozialwissenschaften.isEmpty())) {
			this.addFehler(GostBelegungsfehler.GOST30_SW_10);
			return;
		}
		if (this.manager.pruefeBelegungExistiert(this.sozialwissenschaften, GostHalbjahr.EF1, GostHalbjahr.EF2, GostHalbjahr.Q11, GostHalbjahr.Q12)) {
			return;
		}
		if (this.zusatzkursFachbelegungen !== null) {
			for (const zkBelegung of this.zusatzkursFachbelegungen) {
				if (this.sozialwissenschaften.contains(zkBelegung)) {
					return;
				}
			}
		}
		this.addFehler(GostBelegungsfehler.GOST30_SW_10);
	}

	/**
	 * Gesamtprüfung Punkte 43:
	 * Prüft die Belegung von Religion und Philosophie in der EF. Wird Philosophie als Ersatz belegt, so wird auch geprüft,
	 * ob eine weitere Gesellschaftswissenschaft belegt wurde.
	 */
	private pruefeReligionEF(): void {
		for (const halbjahr of GostHalbjahr.getEinfuehrungsphase()) {
			if (this.manager.pruefeBelegungExistiertEinzeln(this.religion, halbjahr)) {
				continue;
			}
			if ((!this.manager.pruefeBelegung(this.philosophie, halbjahr)) || (this.manager.pruefeDurchgaengigkeit(this.philosophie) && (this.manager.zaehleBelegungInHalbjahren(this.gesellschaftswissenschaften, halbjahr) <= 1))) {
				this.addFehler(GostBelegungsfehler.GOST30_RE_10);
				break;
			}
		}
	}

	/**
	 * Gesamtprüfung Punkt 44:
	 * Prüft die Belegung von Religion und Philosophie. Wird Philosophie als Ersatz belegt, so wird auch geprüft, ob eine weitere
	 * Gesellschaftswissenschaft belegt wurde.
	 */
	private pruefeReligionQ1(): void {
		let anzahlErsatzGE: number = 0;
		let anzahlErsatzSW: number = 0;
		for (const halbjahr of GostHalbjahr.getHalbjahreFromJahrgang("Q1")) {
			if (this.manager.pruefeBelegungExistiertEinzeln(this.religion, halbjahr)) {
				continue;
			}
			if (!this.manager.pruefeBelegung(this.philosophie, halbjahr)) {
				this.addFehler(GostBelegungsfehler.GOST30_RE_10);
				return;
			}
			if (this.manager.pruefeDurchgaengigkeit(this.philosophie) && (this.manager.zaehleDurchgaengigeBelegungen(this.gesellschaftswissenschaften) > 1)) {
				continue;
			}
			if (!this.manager.pruefeDurchgaengigkeit(this.philosophie) && (this.manager.zaehleDurchgaengigeBelegungen(this.gesellschaftswissenschaften) > 0)) {
				continue;
			}
			if (this.manager.zaehleBelegungInHalbjahren(this.sonstige_gesellschaftswissenschaften, halbjahr) > 0) {
				continue;
			}
			let found: boolean = false;
			if (halbjahr as unknown === GostHalbjahr.Q11 as unknown) {
				if (this.manager.pruefeBelegungExistiertEinzeln(this.geschichte, halbjahr) && (this.manager.zaehleBelegungInHalbjahren(this.geschichte, ...GostHalbjahr.getQualifikationsphase()) > 2)) {
					anzahlErsatzGE++;
					found = true;
				}
				if (this.manager.pruefeBelegungExistiertEinzeln(this.sozialwissenschaften, halbjahr) && (this.manager.zaehleBelegungInHalbjahren(this.sozialwissenschaften, ...GostHalbjahr.getQualifikationsphase()) > 2)) {
					anzahlErsatzSW++;
					found = true;
				}
			} else {
				const hatErsatzQ11: boolean = (anzahlErsatzGE === 1) || (anzahlErsatzSW === 1);
				if ((!hatErsatzQ11 || (anzahlErsatzGE === 1)) && this.manager.pruefeBelegungExistiertEinzeln(this.geschichte, halbjahr) && (this.manager.zaehleBelegungInHalbjahren(this.geschichte, ...GostHalbjahr.getQualifikationsphase()) > 2 + anzahlErsatzGE)) {
					anzahlErsatzGE++;
					found = true;
				}
				if ((!hatErsatzQ11 || (anzahlErsatzSW === 1)) && this.manager.pruefeBelegungExistiertEinzeln(this.sozialwissenschaften, halbjahr) && (this.manager.zaehleBelegungInHalbjahren(this.sozialwissenschaften, ...GostHalbjahr.getQualifikationsphase()) > 2 + anzahlErsatzSW)) {
					anzahlErsatzSW++;
					found = true;
				}
			}
			if (found) {
				continue;
			}
			this.addFehler(GostBelegungsfehler.GOST30_RE_10);
			break;
		}
	}

	/**
	 * Gesamtprüfung Punkt 55:
	 * Prüft, ob Fehler bei der Kontinuität bei Philosophie und Religion nur durch die Ersatzfachregelung bei Religion
	 * zustandekommen und damit zulässig sind.
	 */
	private pruefeReligionKontinuitaet(): void {
		if (this.philosophie === null) {
			return;
		}
		let hatKontinuitaetPL: boolean = true;
		let hatKontinuitaetRE: boolean = true;
		let hatteRE: boolean = false;
		for (const halbjahr of GostHalbjahr.values()) {
			const hatPL: boolean = this.manager.pruefeBelegung(this.philosophie, halbjahr);
			const hatRE: boolean = this.manager.pruefeBelegungExistiertEinzeln(this.religion, halbjahr);
			if (!hatRE && hatPL) {
				hatKontinuitaetPL = true;
			}
			if (hatPL && !hatKontinuitaetPL) {
				if (hatRE) {
					this.addFehler(GostBelegungsfehler.GOST30_E1BEL_10);
				}
			}
			if (hatRE && !hatKontinuitaetRE) {
				if (!hatPL) {
					this.addFehler(GostBelegungsfehler.GOST30_E1BEL_10);
				}
			}
			if (hatRE && !hatteRE && halbjahr.istIn(GostHalbjahr.Q21, GostHalbjahr.Q22)) {
				this.addFehler(GostBelegungsfehler.GOST30_E1BEL_10);
			}
			hatKontinuitaetPL = hatKontinuitaetPL && hatPL;
			hatKontinuitaetRE = hatKontinuitaetRE && (hatRE || hatPL);
			hatteRE = hatteRE || hatRE;
		}
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.abschluss.gost.belegpruefung.abi2030.Abi30BelegpruefungGesellschaftswissenschaftenUndReligion';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.abschluss.gost.GostBelegpruefung', 'de.svws_nrw.core.abschluss.gost.belegpruefung.abi2030.Abi30BelegpruefungGesellschaftswissenschaftenUndReligion'].includes(name);
	}

	public static readonly class = new Class<Abi30BelegpruefungGesellschaftswissenschaftenUndReligion>('de.svws_nrw.core.abschluss.gost.belegpruefung.abi2030.Abi30BelegpruefungGesellschaftswissenschaftenUndReligion');

}

export function cast_de_svws_nrw_core_abschluss_gost_belegpruefung_abi2030_Abi30BelegpruefungGesellschaftswissenschaftenUndReligion(obj: unknown): Abi30BelegpruefungGesellschaftswissenschaftenUndReligion {
	return obj as Abi30BelegpruefungGesellschaftswissenschaftenUndReligion;
}
